import Layout from '../../internal/Layout.vue'
import CalledsPage from './calleds/calleds.vue'
import ManageCalled from './components/manageCalled/manageCalled.vue'

const CallsRoutes = {
  component: Layout,
  children: [
    {
      name: 'calleds',
      path: '/',
      component: CalledsPage,
      meta: {
        module: 'chamados',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newCalled',
      path: '/newCalled',
      component: ManageCalled,
      meta: {
        module: 'chamados',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editCalled',
      path: '/editCalled/:calledId',
      component: ManageCalled,
      props: true,
      meta: {
        module: 'chamados',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default CallsRoutes
